import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as StatusBooking from 'src/app/shared/constant/status-booking';

@Component({
  selector: 'no-vehicles-found',
  templateUrl: './no-vehicles-found.component.html',
  standalone: false
})
export class NoVehiclesFoundComponent {
  @Input() bookingStatus?: string;
  @Output() closeBooking = new EventEmitter<void>();
  @Output() viewBookingDocument = new EventEmitter<void>();

  protected readonly BookingStatus = StatusBooking;
} 